import ApiService from "../../../services/ApiService";
import { WORD_WHEEL_QUEST_APP_CODE } from "../wordWheelQuestCommerce";

function readBalance(payload) {
    const n = Number(payload?.creditBalance);
    return Number.isFinite(n) && n >= 0 ? n : 0;
}

const MobileCreditApi = {
    fetchBalance: async (appCode = WORD_WHEEL_QUEST_APP_CODE) => {
        const data = await ApiService.getData("/home/credit/balance", { appCode });
        if (data?.code === "FAILURE") {
            throw new Error(data.message || "Failed to load credit balance");
        }
        return {
            appCode: data?.appCode || appCode,
            creditBalance: readBalance(data),
        };
    },

    fetchProducts: async () => {
        const data = await ApiService.getData("/home/credit/products");
        if (data?.code === "FAILURE") {
            throw new Error(data.message || "Failed to load products");
        }
        return Array.isArray(data) ? data : [];
    },

    verifyIapPurchase: async ({
        appCode = WORD_WHEEL_QUEST_APP_CODE,
        productId,
        transactionId,
        rawPayload,
    }) => {
        const data = await ApiService.postData("/home/credit/iap/verify", {
            appCode,
            productId,
            transactionId,
            rawPayload,
        });
        if (data?.code === "FAILURE") {
            throw new Error(data.message || "Purchase verification failed");
        }
        return {
            ...data,
            creditBalance: readBalance(data),
        };
    },

    consumeCredits: async ({
        appCode = WORD_WHEEL_QUEST_APP_CODE,
        featureUsed,
        creditsConsumed,
    }) => {
        const data = await ApiService.postData("/home/credit/consume", {
            appCode,
            featureUsed,
            creditsConsumed,
        });
        if (data?.code === "FAILURE") {
            throw new Error(data.message || "Failed to spend credits");
        }
        return {
            ...data,
            creditBalance: readBalance(data),
        };
    },
};

export default MobileCreditApi;
